import axios, { AxiosRequestConfig } from 'axios';
import { requestInterceptor } from '@/sidebar/infrastructure/interceptors/requestInterceptor';
import { errorResponseHandler } from '@/sidebar/infrastructure/interceptors/errorHandler';

export const partner = () => {
  const instance = axios.create({
    baseURL: `${process.env.API_GATEWAY}/partner`,
    headers: {
      Accept: `application/vnd.creditas.v1+json`,
      'Content-Type': 'application/json',
      'X-Tenant-Id': 'creditasbr',
    },
  });

  instance.interceptors.request.use((request: AxiosRequestConfig) =>
    requestInterceptor(request),
  );

  instance.interceptors.response.use((response) => {
    if (response.data) return response.data;
    return response;
  }, errorResponseHandler);

  return instance;
};
